/** @see {@link https://console.statsig.com/1G3Xqca75leoEUUlzU7xDl/gates} */
export enum FeatureGates {
  MesaCardInviteEnabled = 'mesa_card_invite_flow_enabled',
  MesaEmployees = 'mesa_employees',
  EndToEndUsers = 'end_to_end_users',
  PointRedemptionForStatementCredit = 'point_redemption_for_statement_credit',
  MesaCardEnabled = 'mesa_card_enabled',
  CardApplicationOfferCodeEnabled = 'card_application_offer_code_enabled',
  CardReferrals = 'card_referrals',
  PointsTransferComingSoonEnabled = 'points_transfer_coming_soon_enabled',
  PointsTransferAscendaEnabled = 'points_transfer_ascenda_enabled',
  PointsTransferOmniEnabled = 'points_transfer_omni_enabled',
  CardInTransitUiEnabled = 'card_in_transit_ui_enabled',
  PointsLedgerEnabled = 'points_ledger_ui_enabled',
  RecaptchaEnabled = 'enable_recaptcha',
  CardApplicationSardineEnabled = 'card_application_sardine_customer_risk_gate',
  PointsToCashForMortgageEnabled = 'turn_points_into_cash_for_your_mortgage_enabled',
  PushProvisioningEnabled = 'push_provisioning_enabled',
  VirtualCardWithoutPhysicalActivationEnabled = 'virtual_card_without_physical_activation_enabled',
  InstacartBenefitEnabled = 'instacart_benefit_enabled',
}
